import { createActionCreator } from '../common/actions'

import type { AlbumListFilter, AlbumListSortOrder } from './reducer'

export const AlbumListFilterSet = createActionCreator<AlbumListFilter>('ALBUM_LIST_FILTER_SET')
export const AlbumListSortModeSet = createActionCreator<AlbumListSortOrder>(
    'ALBUM_LIST_SORT_MODE_SET',
)
